export default __webpack_public_path__ + "static/media/Eye_normal.42803899.svg";